var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.object.error_data
    ? _c(
        "div",
        {
          key:
            _vm.object.error_data.ach_access_denied &&
            _vm.object.error_data.ach_access_denied.redirect,
          staticClass: "k-item k-admin-release body denied",
        },
        [
          _c("i-lock", { staticClass: "icon", attrs: { title: "Denied" } }),
          _c("span", { staticClass: "text" }, [_vm._v("Permission denied")]),
        ],
        1
      )
    : _c(
        "div",
        { key: _vm.object.id, staticClass: "k-item k-admin-release body" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "w-btn-icon",
                {
                  staticClass: "drag-handle",
                  attrs: { "no-hover": "", size: "lg2" },
                },
                [
                  _c("i-drag", {
                    staticClass: "icon",
                    attrs: { title: "Drag to reorder" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "label" },
                [
                  _c("div", {
                    staticClass: "label",
                    domProps: {
                      innerHTML: _vm._s(
                        "" +
                          _vm.releasePrefix +
                          (_vm.object.title && _vm.object.title.rendered)
                      ),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.setCurrentObject.apply(null, arguments)
                      },
                    },
                  }),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.active
                        ? _c("i-plus", {
                            staticClass: "icon",
                            attrs: { title: "Collapse" },
                          })
                        : _c("i-minus", {
                            staticClass: "icon",
                            attrs: { title: "Collapse" },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("transition", { attrs: { name: "height", appear: "" } }, [
            _c(
              "div",
              { staticClass: "info" },
              [
                _vm._l(_vm.object.restrictions, function (value, key) {
                  return [
                    key === "preview"
                      ? [
                          value
                            ? _c(
                                "div",
                                { staticClass: "tag" },
                                [
                                  _c("i-video", {
                                    staticClass: "icon",
                                    attrs: { decorative: "" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      "preview: " + _vm._s("#" + value.ID)
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : key === "show"
                      ? [
                          value
                            ? _c(
                                "div",
                                { staticClass: "tag" },
                                [
                                  _c("i-eye", {
                                    staticClass: "icon",
                                    attrs: { title: "Visible to unpermitted" },
                                  }),
                                  _c("span", [_vm._v("visible")]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : key === "product"
                      ? [
                          value && value.ID
                            ? _c(
                                "div",
                                { staticClass: "tag" },
                                [
                                  _c("i-cart", {
                                    staticClass: "icon",
                                    attrs: { title: "Associted product" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      "product: " + _vm._s("#" + value.ID)
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : key === "users"
                      ? _vm._l(value, function (user) {
                          return _c(
                            "div",
                            { staticClass: "tag" },
                            [
                              _c("i-lock-open", {
                                staticClass: "icon",
                                attrs: { title: "Visible to" },
                              }),
                              _c("span", [
                                _vm._v("user: " + _vm._s(user.display_name)),
                              ]),
                            ],
                            1
                          )
                        })
                      : key === "show"
                      ? [_c("span")]
                      : key !== "plus" && value
                      ? _c(
                          "div",
                          { staticClass: "tag" },
                          [
                            _c("i-lock-open", {
                              staticClass: "icon",
                              attrs: { title: "Visible to" },
                            }),
                            _c("span", [_vm._v(_vm._s(key))]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
          _c("transition", { attrs: { name: "height", appear: "" } }, [
            _vm.active
              ? _c(
                  "div",
                  { staticClass: "more" },
                  [
                    _c("k-video-player", { attrs: { content: _vm.object } }),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _vm._l(_vm.object, function (item, label) {
                          return [
                            _c("div", { staticClass: "key" }, [
                              _vm._v(_vm._s(label)),
                            ]),
                            _c("json-tree", {
                              staticClass: "value",
                              attrs: { data: item },
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }